var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactivateUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 113,
    viewBox: "0 0 114 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 56.5,
    r: 56.5,
    fill: "#FFCACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 36.333C59.2405 36.333 61.8689 37.4217 63.8067 39.3596C65.7446 41.2974 66.8333 43.9258 66.8333 46.6663C66.8333 51.7038 63.2166 55.9147 58.4375 56.8188L46.3475 44.7288C46.8002 42.3676 48.0614 40.2378 49.9142 38.7056C51.767 37.1734 54.0957 36.3344 56.5 36.333ZM57.2233 62.1663L72.7233 77.6663L77.1666 82.1097L73.8858 85.4163L66.1358 77.6663H35.8333V72.4997C35.8333 67.7463 42.2916 63.7422 50.9975 62.528L32.6816 44.2122L35.9625 40.9313L57.2233 62.1663ZM77.1666 72.4997V75.548L64.6116 62.993C72 64.5688 77.1666 68.2372 77.1666 72.4997Z",
    fill: "#BF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateUser);
export default __webpack_public_path__ + "static/media/deactivateUser.92081aeb5f6fe8d3bf44bac8dacb7c73.svg";
export { ForwardRef as ReactComponent };